import { handleResponseError } from '@/services/globalErrorHandlers';
import axiosFactory from './axiosFactory';
import asyncInterceptor from './interceptors/asyncInterceptor';
import downloadInterceptorBuilder from './interceptors/downloadBuilder';
import retryInterceptor from './interceptors/retryInterceptor';
import refreshTokenExpirationInterceptor from './interceptors/refreshTokenExpirationInterceptor';
import {
  baseUrl,
  appendUrlInitialVersion,
  urlVersionMatcher,
  decorateBasicHeaders,
} from './common';

function basicRequest(config) {
  const newConfig = config;

  newConfig.headers = decorateBasicHeaders(newConfig.headers);

  /**
   * Utilitário usado pelo async e retry.
   * A URL original é guardada aqui pois o axios, quando retorna a resposta, está alterando o valor
   * de config.url, concatenando com baseUrl, mas sem limpar o baseUrl.
   * Esse problema faz com que interceptors como o async e o retry, que trabalham com repetição,
   * fiquem concatenando recursicamente a URL relativa, gerando uma url errada.
   * Por isso a url original é guardada aqui, para ser usada pelos interceptors posteriormente.
   * Esse problema não acontece com URLs absolutas.
   */
  newConfig.$originalUrl = config.$originalUrl || config.url;

  return newConfig;
}


function initialVersionChecker(config) {
  if (urlVersionMatcher.test(config.url)) {
    return config;
  }
  const newConfig = config;
  newConfig.url = appendUrlInitialVersion(config.url);
  return newConfig;
}

function decorateInterceptors(instance, options) {
  // O axios está executando os interceptors de requisição em ordem inversa à declarada.
  instance.interceptors.request.use(basicRequest);
  instance.interceptors.request.use(initialVersionChecker);
  instance.interceptors.request.use(refreshTokenExpirationInterceptor);

  instance.interceptors.response.use(null, retryInterceptor.bind(null, options.retryOptions || {}));

  if (process.env.NODE_ENV !== 'test' && (options.async || options.download)) {
    instance.interceptors.response.use(asyncInterceptor.bind(null, options.asyncOptions || {}));
  }

  if (process.env.NODE_ENV !== 'test' && options.download) {
    downloadInterceptorBuilder(instance);
  }

  instance.interceptors.response
    .use(null, handleResponseError.bind(null, options.errorHandling || {}));
}

export default class Http {
  constructor(options = {}) {
    const instance = axiosFactory({
      baseURL: baseUrl,
      withCredentials: true,
      ...options.axiosConfig,
    });

    decorateInterceptors(instance, options);

    return instance;
  }
}
